<template>
  <div class="collection-list">
    <el-container>
      <el-header>
        <el-form
          :model="queryFormData"
          :inline="true"
          label-width="100px"
          label-position="left"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="项目部">
                <el-select
                  v-model="queryFormData.projectDeptId"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="dept in deptList"
                    :key="dept.applyDeptId"
                    :label="dept.applyDeptName"
                    :value="dept.applyDeptId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目名称">
                <el-input
                  v-model="queryFormData.projectName"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="欠款单位">
                <el-input
                  v-model="queryFormData.debtName"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <template v-if="showAdvanceFilter">
              <el-col :span="6">
              <el-form-item label="开始日期">
                <el-date-picker
                  v-model="queryFormData.startDate"
                  type="month"
                  placeholder="选择月份"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
              <el-col :span="6">
                <el-form-item label="结束日期">
                  <el-date-picker
                    v-model="queryFormData.endDate"
                    type="month"
                    placeholder="选择月份"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审计及竣工情况">
                  <el-select
                    v-model="queryFormData.processStatus"
                    placeholder="请选择"
                    clearable
                  >
                    <!-- 这边真的迷，就要跟通用的反着来。后台的value是用来展示的，label是用来传参的。 -->
                    <el-option
                      v-for="process in processStatusList"
                      :key="process.id"
                      :label="process.value"
                      :value="process.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </template>
            <el-col
              :span="showAdvanceFilter?12:6"
              style="text-align: right;"
            >
              <!-- 其他页有时候会设成12，是因为按钮分出的部分 -->
              <el-form-item>
                <div class="search-btns">
                  <el-button type="primary" icon @click="getList"
                    >查询</el-button
                  >
                  <el-button type="info" icon @click="resetQuery"
                    >重置</el-button
                  >
                  <el-button type="text" @click="toggleAdvance">{{
                    showAdvanceFilter ? "收起" : "高级筛选"
                  }}</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align: right;margin-top: 16px;">
            <!-- <el-button type="primary" @click="getList" icon="el-icon-search"
              >查询</el-button
            > -->
            <!-- <el-button type="primary" @click="resetQuery" icon="el-icon-refresh"
              >重置</el-button
            > -->
            <el-button type="primary" v-if="btnAuthorize.addBtn.btnEnable" @click="addItem" icon="el-icon-plus"
              >新建</el-button
            >
            <el-button type="primary" v-if="btnAuthorize.modifyBtn.btnEnable" @click="editItem" icon="el-icon-edit"
              >修改</el-button
            >
            <el-button
              type="primary"
              @click="editLog"
              icon="el-icon-warning-outline"
              v-if="btnAuthorize.logs.btnEnable"
              >修改记录</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.export.btnEnable"
              @click="exportData"
              icon="el-icon-download"
              >导出</el-button
            >
          </el-row>
        </el-form>
      </el-header>
      <el-main>
        <el-table
          ref="dataTable"
          :data="tableData"
          highlight-current-row
          size="mini"
          height="100%"
          border
          @selection-change="handleSelectionChange"
          @row-click="handleRowClick"
          @row-dblclick="handleRowDbClick"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            label="项目部"
            :show-overflow-tooltip="true"
            prop="projectDeptName"
          ></el-table-column>
          <el-table-column
            label="项目名称"
            :show-overflow-tooltip="true"
            prop="projectName"
          ></el-table-column>
          <el-table-column
            label="欠款单位"
            :show-overflow-tooltip="true"
            prop="debtName"
          ></el-table-column>
          <el-table-column
            label="审计及竣工情况"
            :show-overflow-tooltip="true"
            prop="processStatusDisplayName"
          ></el-table-column>
          <el-table-column
            label="合同金额"
            :show-overflow-tooltip="true"
            min-width="120px"
          >
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.contractPrice) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="审计额或已完成产值"
            :show-overflow-tooltip="true"
            min-width="120px"
          >
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.auditOrFinishPrice) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="已收款"
            :show-overflow-tooltip="true"
            min-width="120px"
          >
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.receiptPriceSum) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="回收比例" :show-overflow-tooltip="true"
            min-width="120px">
              <template slot-scope="scope">
              <span>{{ formatPercent(scope.row.takeBackRate) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="欠款总金额"
            :show-overflow-tooltip="true"
            min-width="120px"
          >
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.debtPriceSum) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作用户"
            :show-overflow-tooltip="true"
            prop="operateUserName"
          ></el-table-column>
          <el-table-column
            label="操作时间"
            :show-overflow-tooltip="true"
            prop="operateTime"
          ></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>

    <!-- 修改记录的弹出框 -->
    <el-dialog title="修改记录" :visible.sync="logDialogVisible" width="40%">
      <el-table
        :data="logDialogList"
        highlight-current-row
        size="mini"
        border
        class="log-table"
      >
        <!-- <el-table-column type="index" width="50"> </el-table-column> -->
        <el-table-column label="操作时间" prop="operateTime"></el-table-column>
        <el-table-column
          label="操作用户"
          prop="operateUserName"
        ></el-table-column>
      </el-table>
      <div style="margin-top: 16px; text-align: center;">
        <el-pagination
          @current-change="handleLogCurrentChange"
          :current-page="logDialogPageIndex"
          :page-size="logDialogPageSize"
          layout="total, prev, pager, next, jumper"
          :total="logDialogTotal"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button type="info" @click="logDialogVisible = false"
          >取消</el-button
        > -->
        <el-button type="primary" @click="logDialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="导出" :visible.sync="exportDialogVisible" width="400px">
      <div>
        <el-checkbox v-model="exportBook">项目部计量台账</el-checkbox>
      </div>
      <div>
        <el-checkbox v-model="exportReceiptsSum">应收账款</el-checkbox>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="exportDialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" @click="confirmExportData">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 收款管理-收款列表
 */
import Constants, { formatQueryDate } from "../../utils/consts";
import {
  getDeptList,
  getProcessStatusList,
  getCollectionList,
  getCollectionItemLog,
  receiptsExportApi
} from "../../services/financeService";
import { formatMoney, formatPercent } from "./utils";
export default {
  name: "CollectionList",
  data() {
    return {
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        export: { key: "export", btnEnable: false }, // 导出
        logs: { key:'logs', btnEnable: false}, // 修改记录
      },
      showAdvanceFilter: false,
      total: 0,
      pageSize: 20,
      pageIndex: 1,
      deptList: [], //可供选择的项目部的列表
      processStatusList: [], // 可供选择的状态值列表
      queryFormData: {
        projectDeptId: undefined, //项目部id
        projectName: "", // 项目名称
        debtName: "", // 欠款单位
        processStatus: undefined, // 审计及竣工情况
        startDate: undefined, // 开始日期
        endDate: undefined // 结束日期
      },
      tableData: [],
      selectedItems: [],
      logDialogList: [],
      logDialogVisible: false,
      logDialogPageIndex: 1,
      logDialogPageSize: 10,
      logDialogTotal: 0,
      exportDialogVisible: false,
      exportBook: true,
      exportReceiptsSum: true
    };
  },
  methods: {
    toggleAdvance() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
    },
    formatPercent,
    formatMoneyNumber: formatMoney,
    onActive(menuCode) {
      this.getDeptList();
      this.getProcessStatusList();
      this.getList();
      this.$getRoleBtns(menuCode, this.btnAuthorize);
    },
    resetQuery() {
      this.queryFormData = {
        projectDeptId: undefined,
        projectName: "",
        debtName: "",
        processStatus: undefined,
        startDate: undefined,
        endDate: undefined
      };
      this.pageIndex = 1;
      this.pageSize = 20;
      this.getList();
    },
    getList() {
      let params = {
        debtName: this.queryFormData.debtName,
        endDate: formatQueryDate(this.queryFormData.endDate),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        processStatus: this.queryFormData.processStatus,
        projectDeptId: this.queryFormData.projectDeptId,
        projectName: this.queryFormData.projectName,
        startDate: formatQueryDate(this.queryFormData.startDate)
      };
      console.log("查询参数", params);
      getCollectionList(params)
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.tableData = res.data || [];
            this.total = res.total || 0;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    getDeptList() {
      // 获取可供选择的项目部的列表
      getDeptList()
        .then(res => {
          if (Constants.Code_OK == res.code) {
            this.deptList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    getProcessStatusList() {
      // 获取可供选择的状态值列表
      getProcessStatusList()
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.processStatusList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.getList();
    },
    handleSelectionChange(val) {
      this.selectedItems = val || [];
    },
    handleRowClick(row, column) {
      // 单击某行
      if (!this.selectedItems) {
        this.selectedItems = [row];
      } else {
        let index = this.selectedItems.indexOf(row);
        if (index != -1) {
          this.selectedItems.splice(index, 1);
        } else {
          this.selectedItems.push(row);
        }
      }
      this.$refs["dataTable"].toggleRowSelection(row);
    },
    handleRowDbClick(row, column) {
      // 某一行数据被双击，就是查看详情
      this.bus.$emit("navMenuChange", {
        routeId: "collectionDetail",
        routeParam: {
          id: row.id,
          projectId: row.projectId,
          monthDate: row.monthDate
        }
      });
    },
    addItem() {
      this.bus.$emit("navMenuChange", {
        routeId: "createCollection"
      });
    },
    editItem() {
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请先选择要修改的目标数据", "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert("一次只能修改一条数据", "提示");
        return;
      }
      let target = this.selectedItems[0];
      if(target.isCurrentFlag != 1) {
        this.$alert("历史记录不支持修改操作", "提示");
        return;
      }
      this.bus.$emit("navMenuChange", {
        routeId: "editCollection",
        routeParam: {
          id: target.id
        }
      });
    },
    editLog() {
      // 查看修改记录，看的是某条数据对应的
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请先选择要查看的目标数据", "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert("只能查看单条数据的修改记录", "提示");
        return;
      }
      let target = this.selectedItems[0];
      // 第一次打开，获取数据第1页数据
      this.logDialogPageIndex = 1;
      this.logDialogList = [];
      getCollectionItemLog({
        receiptsId: target.id,
        pageIndex: this.logDialogPageIndex,
        pageSize: this.logDialogPageSize
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.logDialogList = res.data || [];
            this.logDialogTotal = res.total;
            // for (let i = 0; i < 10; i++) {
            //   this.logDialogList.push({
            //     operateTime: "2020-10-10 12:20:20",
            //     operateUserName: "张三",
            //   });
            // }
            // this.logDialogTotal = 100;
            if (this.logDialogList.length == 0) {
              this.$alert("暂无修改记录", "提示");
            } else {
              this.logDialogVisible = true;
            }
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    handleLogCurrentChange(page) {
      console.log("handleLogCurrentChange", page);
      this.logDialogPageIndex = page;
      this.getLogList();
    },
    getLogList() {
      console.log("获取历史记录");
      let target = this.selectedItems[0];
      getCollectionItemLog({
        receiptsId: target.id,
        pageIndex: this.logDialogPageIndex,
        pageSize: this.logDialogPageSize
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            let data = res.data || [];
            // data.forEach(item => {
            //   item.operateTime += Math.random() * 100;
            // })
            // this.logDialogList = data;
            this.logDialogList = data;
            this.logDialogTotal = res.total;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    exportData() {
      // 导出
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请选择要导出的数据", "提示");
        return;
      }
      this.exportBook = true; // 默认两个都选上
      this.exportReceiptsSum = true;
      this.exportDialogVisible = true;
    },
    confirmExportData() {
      let ids = this.selectedItems.map(item => item.id);
      let exportTypes = [];
      if (this.exportBook) {
        exportTypes.push("book");
      }
      if (this.exportReceiptsSum) {
        exportTypes.push("receiptsSum");
      }
      let params = {
        receiptsIds: ids,
        exportTypes
      };
      receiptsExportApi(params)
        .then(res => {
          if (res.code == Constants.Code_OK) {
            console.log("=======", res.data);
            let url = res.data;
            const a = document.createElement("a");
            a.href = url;
            a.download = "收款记录";
            a.click();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert("操作失败", "提示");
        })
        .finally(() => {
          this.exportDialogVisible = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.collection-list {
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
}

.log-table {
  min-height: 300px;
}
</style>
